// import EventBus from "./eventBus.js";
import firebase from "firebase/app";
import "firebase/messaging";
// import store from "./store";

// const API = import.meta.env.VITE_API //"https://api.tukbot.com/prod/tuk/"
const firebaseConfig = {
  apiKey: "AIzaSyCqii2KtkTLQqemW3de9uCkejFB3vsmrWk",
  authDomain: "tuk-push-notifications.firebaseapp.com",
  databaseURL: "https://tuk-push-notifications.firebaseio.com",
  projectId: "tuk-push-notifications",
  storageBucket: "tuk-push-notifications.appspot.com",
  messagingSenderId: "808714537831",
  appId: "1:808714537831:web:87c1b540d3363d43723dc2",
};

var push = {
  initialise(store) {
    if (store.getters.getBrowser === "Safari") {
      console.log("push notifications don't work on iOS / Safari");
      return;
    }
    if (firebase.apps.length) {
      console.log("firebase app already initialised");
      this.requestPermission(store, firebase.messaging()); // request again just in case
      return;
    }

    firebase.initializeApp(firebaseConfig);

    navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}firebase-messaging-sw.js`)
      .then((registration) => {
        const messaging = firebase.messaging();
        messaging.useServiceWorker(registration);
        // messaging.useServiceWorker(`${import.meta.env.BASE_URL}firebase-messaging-sw.js`);
        messaging.usePublicVapidKey(
          "BI9iyBFdVmxDoNKof5uBo9k8v9Z8pVj4xhoUYaXT_jggdP5h9Qnfs0fEa0sLTDa797z6r2kWDK7vPwglekdIHck"
        );

        this.requestPermission(store, messaging);
      });
  },
  requestPermission(store, messaging) {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notification permission granted.");
        // also need to watch for token update event, otherwise could be stale
        messaging
          .getToken()
          .then((token) => {
            if (token) {
              // console.log("push notification token", token);
              store.commit("setNotificationToken", token);
              if (!store.getters.isLoggedIn) return;
              store.dispatch("setNotificationToken", token);

              messaging.onMessage((payload) => {
                console.log("---- onMessage push notification", payload);
                if (payload.data) store.commit("newNotification", payload.data);
              });
              store.dispatch("logEvent", {
                event: "notification_permission",
                data: token,
              });
            } // otherwise what is currentToken?
          })
          .catch((err) => {
            store.dispatch("logEvent", {
              event: "notification_permission",
              data: `error: ${err}`,
            });
          });
      } else {
        console.log("Unable to get permission to send notifications.");
        store.dispatch("logEvent", {
          event: "notification_permission",
          data: "denied",
        });
      }
    });
  },
};

export default push;
